import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiGetDesktopReviewProductList = (params, isListQuery) => {
  const formattedParams = qs.stringify(params, { arrayFormat: 'repeat' });
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/desktop-review/products/list${(() => {
      if (isListQuery) return `?${queryString}`;
      if (formattedParams) return `?${formattedParams}`;
      return '';
    })()}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDesktopReviewFilters = async (filters = {}) => {
  return Request.call({
    url: `/micro/desktop-review/filters`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: filters,
  });
};
export const apiGetDesktopReviewJobs = async (filters = {}) => {
  return Request.call({
    url: `/micro/desktop-review/list`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: filters,
  });
};
export const apiAddDesktopReviewJob = async (data = {}) => {
  return Request.call({
    url: `/micro/desktop-review/jobs`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data,
  });
};
export const apiGetDesktopReviewJobDocuments = async (jobId) => {
  return Request.call({
    url: `/micro/desktop-review/${jobId}/documents`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDesktopReviewJobTestPlans = async (
  jobId,
  filters = {
    pageNo: 1,
    pageSize: 1000,
  }
) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}/test-plans`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: filters,
  });
};
export const apiGetDesktopReviewJobSummary = async (jobId) => {
  return Request.call({
    url: `/micro/desktop-review/${jobId}/summary`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDesktopReviewJob = async (jobId) => {
  return Request.call({
    url: `/micro/desktop-review/${jobId}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiUpdateDesktopReviewJob = (jobId, data) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}`,
    method: 'PUT',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data,
  });
};
export const apiUpdateDesktopReviewJobtatus = (jobId, status) => {
  return Request.call({
    url: `/micro/desktop-review/${jobId}/status`,
    method: 'PUT',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {
      status,
    },
  });
};
export const apiGetDRDashboard = async (key = 'count-by-type', filters = {}) => {
  return Request.call({
    url: `/micro/desktop-review/dashboard/${key}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: filters,
  });
};
export const apiGetDesktopReviewSchema = async (params = {}) => {
  return Request.call({
    url: `/micro/desktop-review/schema`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params,
  });
};

export const apiGetDesktopReviewProducts = async (id, params = {}) => {
  return Request.call({
    url: `/micro/desktop-review/${id}/products`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params,
  });
};

export const apiDuplicateDesktopReview = async (id) => {
  return Request.call({
    url: `/micro/desktop-review/${id}/duplicate`,
    method: 'POST',
    data: {},
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
